import React from "react";
import T from "prop-types";
import styled from "styled-components/macro";
import RecipeCard from "./RecipeCard";
import { BREAKPOINTS } from "commons/util/breakpoints";
import { SkeletonArray } from "commons/components/Skeleton/Skeleton";

const Box = styled.div`
  display: grid;
  gap: 24px 24px;
  grid-template-columns: repeat(4, 1fr);

  @media (max-width: ${BREAKPOINTS.medium}) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: ${BREAKPOINTS.small}) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

function RecipeGrid({ recipes, isLoading }) {
  return (
    <Box>
      {isLoading ? (
        <SkeletonArray count={12} width="100%" height="228px" />
      ) : (
        <>
          {recipes.map(recipe => (
            <RecipeCard
              key={recipe.id}
              recipeId={recipe.id}
              title={recipe.title}
              imageURL={recipe.imageURL}
              tags={recipe.tags}
              isFavorite={recipe.isFavorite}
              neverCooked={recipe.neverCooked}
              link={`/app/recipes/${recipe.id}`}
            />
          ))}
        </>
      )}
    </Box>
  );
}

RecipeGrid.propTypes = {
  recipes: T.array,
  isLoading: T.bool,
};

export default RecipeGrid;
